$(document).ready(function () {
   $('#load-container').fadeOut(150);
});